"use client";

import Link from "next/link";
import type { ReactNode } from "react";
import { track } from "@/lib/analytics/client";
import type { AnalyticsEvents } from "@/lib/analytics/events";
import { useAuth } from "@/providers/auth-provider";

export type McpOfferPlacement = AnalyticsEvents["mcp_cta_clicked"]["placement"];

/**
 * The one link every MCP offer uses. Signed out (and in the server HTML) it goes to
 * /mcp, which explains the server; a signed-in visitor goes straight to /account/api
 * to create a key. Each click is one `mcp_cta_clicked` event.
 */
export function McpOfferLink({
  placement,
  className,
  children,
}: {
  placement: McpOfferPlacement;
  className?: string;
  children: ReactNode;
}) {
  const { user } = useAuth();
  const signedIn = !!user;
  return (
    <Link
      href={signedIn ? "/account/api" : "/mcp"}
      className={className}
      onClick={() => track("mcp_cta_clicked", { placement, signed_in: signedIn })}
    >
      {children}
    </Link>
  );
}
